import type {Config} from 'next-i18n-router/dist/types';

const EN = 'en';
const ES = 'es';

export const langMap: Record<string, () => Promise<Record<string, unknown>>> = {
  [EN]: () => import('./locales/en/common.json'),
  [ES]: () => import('./locales/es/common.json'),
};

export const languageOptions = [
  {locale: EN, name: 'English'},
  {locale: ES, name: 'Español'},
] as const;

export const fallbackLng = EN;
export const supportedLngs = languageOptions.map(option => option.locale);
export const defaultNS = 'common';

export function getI18nOptions(
  lng: string = fallbackLng,
  ns: string[] = [defaultNS],
) {
  return {
    supportedLngs,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}

export const i18nConfig: Config = {
  locales: supportedLngs,
  defaultLocale: fallbackLng,
  prefixDefault: true,
};
